import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.querySelectorAll('img:not([width]), img:not([height])').forEach(this.#setImageDimensions);
  }

  /**
   * Adds intrinsic width/height to authored RTE images that lack them. Images
   * pasted via the Shopify rich-text editor often omit dimension attributes, so
   * the browser cannot reserve layout space and the page shifts as they load.
   * Setting width/height (paired with the `img { height: auto }` CSS rule) lets
   * the browser derive the aspect ratio and reserve space. The durable fix is to
   * author the attributes in the article body HTML; this is a safety net for
   * existing/legacy content.
   * @param {HTMLImageElement} img
   */
  #setImageDimensions(img) {
    const apply = () => {
      if (!img.naturalWidth || !img.naturalHeight) return;
      if (!img.hasAttribute('width')) img.setAttribute('width', String(img.naturalWidth));
      if (!img.hasAttribute('height')) img.setAttribute('height', String(img.naturalHeight));
    };

    if (img.complete) apply();
    else img.addEventListener('load', apply, { once: true });
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
